import { Link } from 'react-router-dom';
import { Hourglass } from '@phosphor-icons/react';
import { useAuth } from '@/context/AuthContext';
import { fmtDate } from './deletionCopy';

// Shown on every signed-in page while a deletion request is open, so the member can cancel or settle funds.
export default function DeletionPendingBanner() {
  const { user } = useAuth();
  const d = user?.account_deletion;
  if (!d) return null;
  return (
    <Link to="/settings?s=delete" className="flex items-center gap-2 pl-4 pr-16 py-2.5 text-[13px] font-semibold"
      style={{ background: d.status === 'on_hold' ? '#FEF3C7' : '#FEE2E2', color: d.status === 'on_hold' ? '#92400E' : '#991B1B' }}
      data-testid="deletion-pending-banner">
      <Hourglass size={18} weight="fill" />
      <span className="flex-1">
        {d.status === 'on_hold'
          ? 'Suppression de votre compte différée : des fonds ou engagements restent à régler.'
          : `Suppression de votre compte prévue à partir du ${fmtDate(d.scheduled_for)}.`}
      </span>
      <span className="underline">Gérer ou annuler</span>
    </Link>
  );
}
